import axios from "axios";
import { store } from "../../../store/store";
import { getEnv } from "../../../AppConfigs";
import { getDeviceId } from "../../document/util";
import { UAParser } from "ua-parser-js";

const X_API_KEY = getEnv("REACT_APP_X_API_KEY");

const viagsApiDev = axios.create({
  baseURL: getEnv("REACT_APP_CHAT_API_DOMAIN"),
  timeout: 20000,
});

viagsApiDev.interceptors.request.use(
  async (config) => {
    const token = store.getState().user?.current?.accessToken;
    const deviceId = await getDeviceId();
    const parser = new UAParser();
    const result = parser.getResult();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    config.headers = {
      ...config.headers,
      X_DEVICE_UDID: deviceId || "",
      X_APP_NAME: result.browser.name || "",
      X_APP_VERSION: "",
      X_APP_BUILD: "",
      X_DEVICE_OS: result.os.version || "",
      X_DEVICE_PLATFORM: result.os.name || "",
      X_DEVICE_MODEL: result.device.model || "",
      X_DEVICE_NAME: result.browser.name || "",
      X_DEVICE_LOCATION: "",
      X_APP_LANGUAGE: navigator.language || "en-US",
      "X-API-KEY": X_API_KEY || "",
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

viagsApiDev.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default viagsApiDev;
